module.exports = __webpack_public_path__ + "img/GRC.5803d7ca.svg";